import React from 'react'
import { ViewersPeriodChartProps } from './ViewersPeriodChart.types'
import styles from './ViewersPeriodChart.module.scss'
import cl from 'classnames'
import { TabsLine } from 'components/shared'
import { inject } from 'mobx-react'
import {
  STATISTICS_OVERVIEW_PERIOD_CHART_STORE,
  ViewersPeriodChartTabs
} from 'store'
import { MSLine } from 'components/charts'
import { observer } from 'mobx-react-lite'

const ViewersPeriodChartComponent = (props: ViewersPeriodChartProps) => {
  const {
    className,
    style,
    [STATISTICS_OVERVIEW_PERIOD_CHART_STORE]: {
      chartTabs,
      onSelectedTabChange,
      periodChartProps
    }
  } = props

  if (!periodChartProps) return null

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >
      <TabsLine<ViewersPeriodChartTabs>
        tabs={chartTabs}
        onSelectedTabChange={onSelectedTabChange}
      />

      <div style={{ marginTop: 25 }}>
        <MSLine {...periodChartProps} />
      </div>
    </div>
  )
}

const ViewersPeriodChart = inject(
  STATISTICS_OVERVIEW_PERIOD_CHART_STORE
)(observer(ViewersPeriodChartComponent))
export { ViewersPeriodChart }
